import './actionthanks.scss'

import {ActionChannelData, LinkType, ThanksData} from 'campagne/types'
import {ButtonSecondary, ButtonTertiary} from 'views/ui/Button'
import React, {FunctionComponent, useState} from 'react'

import {BannerCta} from '../banner'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {DownloadPromo} from 'views/campagne/promo/downloadpromo'
import {FormValues} from 'views/campagne/pages'
import {Hints} from '../hints'
import {Poster} from 'views/campagne/promo/poster'
import {PracticalPromotion} from '../practical'
import {ShareIcons} from '../share'
import {Theme} from 'views/campagne/theme'
import {dateFromServerDate} from 'util/dates'
import {style} from 'util/campagne/style'
import {useTranslation} from 'util/i18n'

export type ActionthanksType = {}

const styles = style('actionthanks')

export const Actionthanks: FunctionComponent<
	ActionChannelData &
		FormValues & {
			thanks: ThanksData & {hints: Array<{hint: string}>}
			structured_communication_number: string
		} & any
> = (data) => {
	const {
		thanks,
		affiche_with,
		affiche_what,
		affiche_where,
		location_name,
		date_start,
		date_end,
		hour_start,
		hour_end,
		date_has_multiple_days,
		date_has_end_hour,
		path,
		banner,
		structured_communication_number,
		orderlink
	} = data

	const {
		text,
		title: thanksTitle,
		proceeds_text,
		proceeds_link,
		hints_title,
		hints
	} = thanks

	const t = useTranslation('campagne').action

	const poster = {
		organisation: affiche_with,
		sharing: affiche_what,
		location: affiche_where,
		venue: location_name,
		start: dateFromServerDate(date_start),
		end: dateFromServerDate(date_end),
		hasEndDate: date_has_multiple_days,
		hasEndHour: date_has_end_hour
	}
	const convertedScn = convertToScn(structured_communication_number)
	const [isCopied, setCopied] = useState(false)

	return (
		<Theme.Container>
			<div class={styles('cols')}>
				<div class={styles('cols-poster')}>
					<div class={styles('cols-poster-text')}>{text}</div>
					<div class={styles('cols-poster-holder')}>
						<Poster {...poster} />
					</div>
					<div class={styles('cols-poster-hints')}>
						<Hints title={hints_title} hints={hints} />
					</div>
				</div>
				<div class={styles('cols-promotion')}>
					<ButtonSecondary to={path}>{t.watch_page}</ButtonSecondary>
					<div class={styles('cols-promotion-side')}>
						<div class={styles('cols-promotion-side-deposit')}>
							<div class={styles('cols-promotion-side-deposit-container')}>
								<Theme.Wysiwyg mod="white">
									{proceeds_text.replace(
										'[structured_communication_number]',
										convertedScn.split(' ').join('&nbsp;')
									)}
								</Theme.Wysiwyg>
								{proceeds_text.split('[structured_communication_number]')
									.length === 1 && (
									<CopyToClipboard
										text={structured_communication_number}
										onCopy={() => setCopied(true)}
										class={styles('cols-promotion-side-deposit-container-scn')}
									>
										<div>
											<Theme.P mod={['white', 'bold']}>{convertedScn}</Theme.P>
											<span
												class={styles(
													'cols-promotion-side-deposit-container-scn-feedback'
												).is({
													visible: isCopied
												})}
											>
												{t.copied}
											</span>
										</div>
									</CopyToClipboard>
								)}

								<div
									class={styles('cols-promotion-side-deposit-container-button')}
								>
									<ButtonTertiary mod="boldtext" to={proceeds_link.url}>
										{proceeds_link.description}
									</ButtonTertiary>
								</div>
							</div>
						</div>
					</div>
					<div class={styles('cols-promotion-promo')}>
						<PracticalPromotion>
							<Theme.H3
								class={styles('cols-promotion-title')}
								mod={['slantedtoleft', 'marked', 'white']}
							>
								{t.promotion_title}
							</Theme.H3>
							<DownloadPromo {...poster} />
							<PromotionItem title={t.need} link={orderlink} />
							<div class={styles('cols-promotion-item')}>
								<Theme.H5>{t.share_online}</Theme.H5>
								<div class={styles('cols-promotion-item-button')}>
									<ShareIcons />
								</div>
							</div>
						</PracticalPromotion>
					</div>
				</div>
			</div>
			<div class={styles('banner')}>
				<BannerCta
					headingLeft={banner.title1}
					headingRight={banner.title2}
					description={banner.text}
					ctaLink={banner.link}
					{...banner}
				/>
			</div>
		</Theme.Container>
	)
}

const convertToScn = (scn) => {
	const firstPart = scn.substring(0, 3)
	const secondPart = scn.substring(3, 7)
	const thirdPart = scn.substring(7, 12)
	const convertedScn = `+++ ${firstPart} / ${secondPart} / ${thirdPart} +++`
	return convertedScn
}

export const PromotionItem: React.FC<{title: string; link: LinkType}> = ({
	title,
	link
}) => {
	if (!link) return
	return (
		<div class={styles('cols-promotion-item')}>
			<Theme.H5>{title}</Theme.H5>
			{link && (
				<div class={styles('cols-promotion-item-button')}>
					<ButtonSecondary to={link.url}>Bestel je materiaal</ButtonSecondary>
				</div>
			)}
		</div>
	)
}
